import styled from "styled-components";
import { NavLink } from "react-router-dom";

import { Header, Nav, StyledNavLink, Wrap, HomeContainer } from "@/pages/Home";
import { ReactComponent as Logo } from "@/assets/icons/logo.svg";
import HomeFaq from "../Home/components/HomeFaq";
import HomeFooter from "../Home/components/HomeFooter";

const StyledLogo = styled(Logo)`
  height: 20px;
  width: auto;
`;

const Link = styled(NavLink)`
  margin-left: 40px;
  cursor: pointer;
  transition: opacity ease-out 0.2s;
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  &:hover {
    opacity: 0.75;
  }
`;

const PrivacyPolicy = () => {
  return (
    <Wrap>
      <Header>
        <NavLink to="/">
          <StyledLogo />
        </NavLink>
        <Nav>
          <Link to="/">Product</Link>
          <StyledNavLink to="/login">Sign Up</StyledNavLink>
        </Nav>
      </Header>
      <HomeContainer>
        <HomeFaq />
      </HomeContainer>
      <HomeFooter />
    </Wrap>
  );
};

export default PrivacyPolicy;
